<div class="cell" [ngClass]="{'align-left': alignLeft}">
  {{label}}
  <div *ngIf="secondaryLabel" class="secondary">{{secondaryLabel}}</div>
</div>
